import { Center, Img } from '@chakra-ui/react'
import React from 'react'
import { Link as RouterLink  } from 'react-router-dom'
const Thankyou = () => {
  return (
    <div> 
      
        {/* <Img src="https://img.freepik.com/free-photo/cheerful-happy-girls-with-many-shopping-bags-sitting-shopping-cart-isolated-yellow-studio-background_155003-45989.jpg"/> */}
        <Center> 
            <RouterLink to="/"> 
        <Img src="https://play-lh.googleusercontent.com/nswiIv7s-AVKryRnNKiIvbEmOWjBTitXJivAAcCWxRQq4ifuoCH7uIS8btdorh31oiM" w={"100%"} h={700} m={5} />
        </RouterLink>
        </Center>
    </div>
  )
}

export default Thankyou